// 9fbef606107a605d69c0edbcd8029e5d
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import { spcTitleCase } from '@tcp/core/src/utils/utils';
import { getPriceData } from '@tcp/core/src/components/features/browse/PlpTile/views/plpTileHelpers/priceAndWishlistHelper';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
} from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import style, {
  MerchantTag,
  OfferPrice,
  StrikedThroughPrice,
  PriceWrapper,
  ListPriceWrapper,
} from '../styles/Price.style';
import SafeComponent from '../../../../../../common/hoc/withErrorBoundary/errorBoundary';

const Price = ({
  minListPrice,
  minOfferPrice,
  merchantTag,
  isHideOriginalPrice,
  currencyAttributes,
  currencySymbol,
  keepAlive,
  className,
}) => {
  const outOfStockCaps = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_COMMON_BROWSE_LABELS}.lbl_common_outOfStockCaps`,
    globalCommonBrowseLabels
  );
  const hasMounted = useHasMounted();
  const { offerPrice, listPrice } = useMemo(
    () =>
      getPriceData({
        minListPrice,
        minOfferPrice,
        currencySymbol,
        currencyAttributes,
      }),
    [minListPrice, minOfferPrice, currencySymbol, currencyAttributes]
  );
  return !keepAlive ? (
    <PriceWrapper className="price-tag-wrapper">
      <OfferPrice className="offer-price-tag">{offerPrice}</OfferPrice>
      {hasMounted && listPrice !== offerPrice && !isHideOriginalPrice ? (
        <ListPriceWrapper className="strike-price-and-merchant-tag-wrapper">
          <StrikedThroughPrice className="strike-price">{listPrice}</StrikedThroughPrice>
          {merchantTag && <MerchantTag className="merchant-tag">{merchantTag}</MerchantTag>}
        </ListPriceWrapper>
      ) : null}
    </PriceWrapper>
  ) : (
    <PriceWrapper className={`${className} keep-alive-text`}>
      {spcTitleCase(outOfStockCaps)}
    </PriceWrapper>
  );
};

Price.propTypes = {
  minListPrice: PropTypes.number,
  minOfferPrice: PropTypes.number,
  merchantTag: PropTypes.string,
  isHideOriginalPrice: PropTypes.bool,
  currencySymbol: PropTypes.string,
  currencyAttributes: PropTypes.shape({}),
  keepAlive: PropTypes.bool,
  className: PropTypes.string,
};
Price.defaultProps = {
  minListPrice: 0,
  minOfferPrice: 0,
  merchantTag: '',
  isHideOriginalPrice: false,
  currencySymbol: '$',
  currencyAttributes: {},
  keepAlive: false,
  className: '',
};

export default withStyles(SafeComponent(Price), style);
export { Price as PriceVanilla };
